"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiGoods = /** @class */ (function (_super) {
    __extends(ApiGoods, _super);
    function ApiGoods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_NEW_ID = "/api/goods/create";
        _this.GET_LIST = "/api/goods/list";
        _this.GET_ITEM = "/api/goods/get";
        _this.SET_ITEM = "/api/goods/set";
        _this.DELETE_ITEM = "/api/goods/delete";
        /**
         * goods Id 생성
         * @param accesstoken
         * @param type
         * @returns
         */
        _this.getGoodsNewId = function (accesstoken, type, language) {
            var data = {
                type: type,
                language: language,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_NEW_ID,
                data: data,
            });
            return config;
        };
        /**
         * goods List 호출
         * @param accesstoken
         * @param type
         * @returns
         */
        _this.getGoodsList = function (accesstoken, type, language) {
            var data = {
                type: type,
                language: language,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_LIST,
                data: data,
            });
            return config;
        };
        /**
         * goods Item 삭제
         * @param accesstoken
         * @param productId
         * @returns
         */
        _this.deleteGoodsItem = function (accesstoken, goodsId) {
            var data = {
                goodsId: goodsId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.DELETE_ITEM,
                data: data,
            });
            return config;
        };
        /**
         * goods Item 정보 불러오기
         * @param accesstoken
         * @param productId
         * @returns
         */
        _this.getGoodsItem = function (accesstoken, goodsId) {
            var data = {
                goodsId: goodsId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_ITEM,
                data: data,
            });
            return config;
        };
        /**
         * goods Item 저장
         * @param accesstoken
         * @param productId
         * @returns
         */
        _this.setGoodsItem = function (accesstoken, data) {
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.SET_ITEM,
                data: data,
            });
            return config;
        };
        return _this;
    }
    ApiGoods.getInstance = function (initValue) {
        if (!ApiGoods.classInstance) {
            this.classInstance = new ApiGoods(initValue);
        }
        return this.classInstance;
    };
    return ApiGoods;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiGoods;
